export const commonStyles = (FOUNDATIONS, FONT, VARIANT_TOKENS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        border_radius: FOUNDATIONS.radius_250,
        ...VARIANT_TOKENS.rootContainer,
    },
    headerButton: {
        display: 'flex',
        width: '100%',
        cursor: 'pointer',
        border_radius: FOUNDATIONS.radius_250,
        padding: FOUNDATIONS.spacing_250,
        ...VARIANT_TOKENS.headerButton,
    },
    innerContent: {
        // This css and container is key for the transition effect
        min_height: '0',
        overflow: 'hidden',
        ...VARIANT_TOKENS.innerContent,
    },
    content: {
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
        overflow: 'hidden',
        display: 'grid',
        // when state is collapsed, grid_template_rows will be set to '0fr'
        grid_template_rows: '1fr',
        // this is the transition effect for expanding/collapsing. Note that padding has to be defined with the same format in order to work.
        transition: `grid-template-rows ${FOUNDATIONS.duration_150} ease-out, padding ${FOUNDATIONS.duration_150} ease-out`,
        ...VARIANT_TOKENS.content,
    },
});
//# sourceMappingURL=commonStyles.js.map